/**
 * Environment Utilities
 * Controls console logs and navigation based on environment mode
 * 
 * Console logs: Only work in TEST mode (disabled in dev, qa, production)
 * Navigation: Disabled in TEST mode, enabled in dev, qa, production
 * 
 * To use: Set REACT_APP_ENV_MODE in your .env file
 * Options: dev, test, qa, production
 */

// Helper to extract clean value from env var (removes comments and trims)
const getCleanEnvValue = (value: string | undefined, defaultVal: string): string => {
  if (!value) return defaultVal;
  // Split by # to remove inline comments, then take first part and trim
  const cleanValue = value.split('#')[0].trim().toLowerCase();
  return cleanValue || defaultVal;
};

// Get environment mode from .env file (dev, test, qa, production)
// Priority: REACT_APP_ENV_MODE > NODE_ENV > default to 'production'
const ENV_MODE = getCleanEnvValue(process.env.REACT_APP_ENV_MODE || process.env.NODE_ENV || 'production', 'production');
console.log("ENV_MODE (cleaned):", JSON.stringify(ENV_MODE), "Length:", ENV_MODE.length);

// Check if current mode is TEST
export const isTestMode = () => {
  const mode = ENV_MODE;
  const result = mode === 'test';
  // console.log("isTestMode check - Mode:", JSON.stringify(mode), "===", JSON.stringify('test'), "Result:", result);
  return result;
};

// Safe console.log - only works in test mode (disabled in dev, qa, production)
export const safeConsole = {
  log: (...args: any[]) => {
    if (isTestMode()) {
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    if (isTestMode()) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    if (isTestMode()) {
      console.error(...args);
    }
  },
  info: (...args: any[]) => {
    if (isTestMode()) {
      console.info(...args);
    }
  },
  debug: (...args: any[]) => {
    if (isTestMode()) {
      console.debug(...args);
    }
  },
};

// Safe navigate function - disabled in TEST mode, enabled in dev, qa, production
export const createSafeNavigate = (navigate: any) => {
  return (path: string | number, options?: any) => {
    // Check mode directly (clean the value to remove comments)
    const rawMode = process.env.REACT_APP_ENV_MODE || process.env.NODE_ENV || 'production';
    const currentMode = getCleanEnvValue(rawMode, 'production');
    const isTest = currentMode === 'test';
    
    // console.log("SafeNavigate check - Raw:", rawMode, "Cleaned:", currentMode, "isTest:", isTest, "Path:", path);
    
    // Navigation disabled ONLY in test mode
    if (isTest) {
      // Navigation disabled in test mode - BLOCK navigation
      // console.log("❌ Navigation BLOCKED in TEST mode. Path:", path);
      return; // Stop here - don't navigate
    }
    
    // Navigation enabled in dev, qa, production - execute navigation
    // console.log("✅ Navigation ALLOWED. Executing navigation to:", path);
    navigate(path, options);
  };
};

